"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchableSelect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _command = require("@design/ui/command");
var _popover = require("@design/ui/popover");
var _portalLayer = require("@common/components/share/portal-layer");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CUSTOM_VALUE_ITEM = "custom-value";
function selectionSummary(options, selected, customDisplayValue) {
  var selectedLabels = selected.map(function (index) {
    var _options$index;
    return (_options$index = options[index]) === null || _options$index === void 0 ? void 0 : _options$index.label;
  }).filter(function (label) {
    return !!label;
  });
  if (selectedLabels.length === 0) return customDisplayValue;
  if (selectedLabels.length === 1) return selectedLabels[0];
  return "".concat(selectedLabels.length, " selected");
}
function optionsMatching(options, query) {
  return options.map(function (option, index) {
    return {
      option: option,
      index: index
    };
  }).filter(function (_ref) {
    var option = _ref.option;
    return (0, _foldedTextSearch.matchesSearch)(option.label, query) || (0, _foldedTextSearch.matchesSearch)(option.description, query);
  });
}
var SearchableSelect = exports.SearchableSelect = function SearchableSelect(_ref2) {
  var id = _ref2.id,
    options = _ref2.options,
    selected = _ref2.selected,
    multiSelect = _ref2.multiSelect,
    onToggle = _ref2.onToggle,
    label = _ref2.label,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    onCustomValue = _ref2.onCustomValue,
    _ref2$customDisplayVa = _ref2.customDisplayValue,
    customDisplayValue = _ref2$customDisplayVa === void 0 ? "" : _ref2$customDisplayVa;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    query = _useState4[0],
    setQuery = _useState4[1];
  var trimmedQuery = query.trim();
  var matchingOptions = optionsMatching(options, trimmedQuery);
  var offersCustomValue = !!onCustomValue && trimmedQuery.length > 0 && !options.some(function (option) {
    return (0, _foldedTextSearch.equalsFolded)(option.label, trimmedQuery);
  });
  var summary = selectionSummary(options, selected, customDisplayValue);
  function changeOpen(open) {
    setIsOpen(open);
    setQuery("");
  }
  function pick(index) {
    onToggle(index);
    if (!multiSelect) changeOpen(false);
  }
  function pickCustomValue() {
    onCustomValue === null || onCustomValue === void 0 || onCustomValue(trimmedQuery);
    changeOpen(false);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_popover.Popover, {
    modal: true,
    open: isOpen,
    onOpenChange: changeOpen,
    "data-sentry-element": "Popover",
    "data-sentry-component": "SearchableSelect",
    "data-sentry-source-file": "SearchableSelect.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverTrigger, {
      asChild: true,
      "data-sentry-element": "PopoverTrigger",
      "data-sentry-source-file": "SearchableSelect.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
        id: id,
        type: "button",
        variant: "outline",
        role: "combobox",
        "aria-label": label,
        disabled: disabled,
        className: "w-full justify-between font-normal",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "SearchableSelect.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: summary ? "truncate" : "truncate text-foreground-muted",
          children: summary || "Select…"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
          "data-icon": "inline-end",
          "data-sentry-element": "KeyboardArrowDownIcon",
          "data-sentry-source-file": "SearchableSelect.tsx"
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverContent, _objectSpread(_objectSpread({}, _portalLayer.PORTAL_LAYER_PROPS), {}, {
      align: "start",
      className: "w-(--radix-popover-trigger-width) p-0",
      "data-sentry-element": "PopoverContent",
      "data-sentry-source-file": "SearchableSelect.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.Command, {
        shouldFilter: false,
        "data-sentry-element": "Command",
        "data-sentry-source-file": "SearchableSelect.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandInput, {
          autoFocus: true,
          placeholder: "Search options\u2026",
          value: query,
          onValueChange: setQuery,
          "data-sentry-element": "CommandInput",
          "data-sentry-source-file": "SearchableSelect.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandList, {
          "aria-multiselectable": multiSelect,
          "data-sentry-element": "CommandList",
          "data-sentry-source-file": "SearchableSelect.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandEmpty, {
            "data-sentry-element": "CommandEmpty",
            "data-sentry-source-file": "SearchableSelect.tsx",
            children: "No matching options."
          }), matchingOptions.map(function (_ref3) {
            var option = _ref3.option,
              index = _ref3.index;
            var isSelected = selected.includes(index);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandItem, {
              value: String(index),
              checkbox: multiSelect ? isSelected : undefined,
              "data-checked": isSelected,
              onSelect: function onSelect() {
                return pick(index);
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                className: "flex min-w-0 flex-col",
                children: [option.label, option.description ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "text-caption text-foreground-muted",
                  children: option.description
                }) : null]
              })
            }, index);
          }), offersCustomValue ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandItem, {
            value: CUSTOM_VALUE_ITEM,
            onSelect: pickCustomValue,
            children: ["Use custom value: ", trimmedQuery]
          }) : null]
        })]
      })
    }))]
  });
};